// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-klEM","select":"styles_select__1xDeF"};